<div echarts [options]="options" class="chart"></div>
